define([],
	function() {

        var valueAtPath = function(obj, path) {
            var pathParts = path.split('.'),
                current = obj
            for (var i = 0; i < pathParts.length && current !== undefined; i++){
                current = current[pathParts[i]]
            }
            if(current == undefined || current == null){
                current = "";
            }
            return current;
        }
        
        var microTemplate = function(template, context){
            var result = template;
            //match functions
            /*result = template.replace(/\{\{\#(.*?)\}\}(.*?)\{\{\/(.*?)\}\}/g, function(i, match, p1, p2, offset, source){
                if(match != p2){
                    return i;
                }
                var func = valueAtPath(context, match);
                if(func && typeof func == 'function'){
                    return func()(p1, null);
                }
                return i;
            });*/
            //Match simple variables starting with letter
            result = template.replace(/\{\{([a-zA-Z].*?)\}\}/g, function(i, match) {
                return valueAtPath(context, match);
            });
            return result;
        }
		return microTemplate;
	}
);





//////////////////
// WEBPACK FOOTER
// ./utils/microTemplate.js
// module id = 48
// module chunks = 0